async function fetchRequest(url, method, body = null) {
  try {
    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (body) options.body = JSON.stringify(body);
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorMessage = `Error: ${response.status} - ${response.statusText}`;
      throw new Error(errorMessage);
    }
    return await response.json();
  } catch (error) {
    console.error(`Request failed for ${method} ${url}:`, error);
    throw error;
  }
}

// Only include the updateCart function, as needed for attributes
function updateCart(change) {
  if (
    !change ||
    typeof change.id === "undefined" ||
    typeof change.quantity !== "number"
  ) {
    // For attributes update, Shopify expects an object with note or attributes, so skip this validation
    // Accept any object for attributes update
    return fetchRequest("/cart/update.js", "POST", change);
  }
  return fetchRequest("/cart/change.js", "POST", change);
}

function updateCartAttributes(attributes) {
  // Accepts either note or attributes object
  return updateCart(attributes);
}

window.updateCartAttributes = updateCartAttributes;
